import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import { IButtonDirective, MODAL_DATA, ModalOptions, ModalRef } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { MediaType } from "@front/m19-api-client";
import { MediaComponent } from "@m19-board/shared/media/media/media.component";

@Component({
  selector: "app-media-preview-modal",
  imports: [IButtonDirective, TranslocoDirective, MediaComponent],
  templateUrl: "./media-preview-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaPreviewModalComponent {
  static readonly defaultModalOptions: Omit<ModalOptions<unknown>, "data"> = { size: "lg" };

  protected readonly modalData = inject<MediaPreviewModalData>(MODAL_DATA);
  protected readonly modalRef = inject(ModalRef);
}

export interface MediaPreviewModalData {
  mediaSource: string;
  mediaType: MediaType;
}
